import React from "react";
import PropTypes from "prop-types";

import { getTestEmail } from "../../../../utils/user-helpers";
import SvgIcon from "../../../../parts/SvgIcon";

const NoAthletesView = (props, { locals }) => {
  const { activeUser, organizationOwner, activeUserToRequest } = locals;
  const { businessName, name, email, webAppTheme } = activeUser;
  const { referAsClients } = activeUser;
  const appName = businessName || name;
  const testEmail = getTestEmail(email);
  const theme = webAppTheme || "dark";
  return (
    <main className="athlete-list no-athletes">
      {!organizationOwner && !activeUser.organizationId && (
        <article className="no-athlete-card">
          {/* <span className="test-badge">Test Account</span> */}
          <SvgIcon
            src={`/img/new-icons/Training-App-${theme}.svg`}
            alt="test app"
            noFilterOnLight={true}
          />

          <h3>{appName} Training App</h3>

          <p className="p2">
            Test your own mobile app as{" "}
            {referAsClients ? "a client" : "an athlete"}. Clicking this button
            will send the email to your account email. You must sign into the
            app using the email:{" "}
            <span className="secondary-text text-[--information]">
              {testEmail}
            </span>
          </p>

          <p className="p2 mt-4 w-full">You will not be charged for this</p>

          <a
            role="button"
            data-button-type="primary"
            href="/coaching-portal/athletes/?modal[type]=test-account"
          >
            Test your app
          </a>
        </article>
      )}

      <article className="no-athlete-card">
        <SvgIcon
          noFilterOnLight={true}
          src={`/img/new-icons/Add-Athlete-${theme}.svg`}
          alt="add user"
        />

        <h3 className="card-title">
          Add First {referAsClients ? "Client" : "Athlete"}
        </h3>

        <p className="p2">
          Add your first {referAsClients ? "client" : "athlete"} to your account
          to begin coaching faster, smarter and better. They will receive an
          invite email to onboard to your app.
        </p>

        <a
          role="button"
          data-button-type="primary"
          href="/coaching-portal/athletes/?modal[type]=invite-athlete"
        >
          Add your first {referAsClients ? "client" : "athlete"}
        </a>
      </article>

      <article className="no-athlete-card">
        <SvgIcon
          noFilterOnLight={true}
          src={`/img/new-icons/MSB-University-${theme}.svg`}
          alt="book"
        />

        <h3 className="card-title">Learn How To Use Our App</h3>

        <p className="p2">
          See the best way to use MyStrengthbook through our MSB University,
          where you can see our different videos which will help you to learn
          the application
        </p>

        <a
          role="button"
          data-button-type="primary"
          href="/coaching-portal/msb-university"
        >
          Learn now
        </a>
      </article>
    </main>
  );
};

NoAthletesView.contextTypes = { locals: PropTypes.object };
export default NoAthletesView;
